import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Divider, FormHelperText } from '@mui/material';
import { Button } from '@mui/material';
import OutlinedInput from '@mui/material/OutlinedInput';
import { getData } from '../../services/fetch-service';
import { useFormik } from 'formik';
import * as Yup from 'yup'
import Swal from 'sweetalert2';


const KruHidrodrini_PaymentFields = () => {
    const navigate = useNavigate();
    const SelectedPayment = useSelector((state) => state.Website.data.PaymentSelected);
    const [NumriSerik, setNumriSerik] = useState();
    const [InstitucioniServiceData, setInstitucioniServiceData] = useState([]);

    const fetchInstitucioniServiceData = async () => {
        try {
            const response = await getData(`Pagesat/GetInstitucionServiceData?llojipagesesID=137&serialNumber=${NumriSerik}`);
            setInstitucioniServiceData(response.data.respond);
        } catch (error) {
            setInstitucioniServiceData([]);
        }
    };

    const handleSearch = () => {
        fetchInstitucioniServiceData();
    };

    const handleBack = () => {
        navigate('/');
    }

    const payment_validationSchema = Yup.object().shape({
        Email: Yup.string().email('Email nuk është valid!').required('Email është obligativ!'),
    });

    const formik = useFormik({
        initialValues: {
            Email: '',
        },
        validationSchema: payment_validationSchema,
        onSubmit: (values) => {
        },
    });

    const handlePay = () => {
        formik.validateForm().then((errors) => {
            if (Object.keys(errors).length === 0) {
                formik.handleSubmit();
            } else {
                formik.setTouched(Object.keys(formik.values).reduce((acc, key) => {
                    acc[key] = true;
                    return acc;
                }, {}));
            }
        });
    }

    return (
        <div className="paysera-home paysera-feilds">
            <div className="home-header">
                <h1 className='headline-font'>
                    {SelectedPayment.description}
                </h1>
            </div>
            <div className="paysera-form-body">
                <div className="form-box search-box">
                    <div className="form-body search-body">
                        <div className="paysera-form search-s">
                            <div className="paysera-inputLabel s-Label">
                                <label htmlFor="Numri Serik">Kërko përmes UNIREF <span className="required">*</span></label>
                                <div className="s-input">
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="UNIREF"
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                        onChange={(event) => setNumriSerik(event.target.value)}
                                    />
                                    <Button type="button" variant="contained" onClick={handleSearch}>
                                        Kërko
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="form-box">
                    <Divider className='subheading-font' textAlign="center">Detajet e pagesës</Divider>
                    <div className="form-body">
                        <div className="paysera-form">
                            <div className="paysera-inputLabel">
                                <label htmlFor="Numri Serik">Konsumatori</label>
                                <OutlinedInput
                                    size="small"
                                    id="outlined-adornment-input"
                                    placeholder="Konsumatori"
                                    disabled
                                    type="text"
                                    value={InstitucioniServiceData.Insured}
                                    aria-describedby="outlined-input-helper-text"
                                    inputProps={{
                                        'aria-label': 'input',
                                    }}
                                />
                            </div>
                            <div className="paysera-inputLabel">
                                <label htmlFor="Numri Serik">Emri</label>
                                <OutlinedInput
                                    size="small"
                                    id="outlined-adornment-input"
                                    placeholder="Emri"
                                    disabled
                                    type="text"
                                    value={InstitucioniServiceData.Insured}
                                    aria-describedby="outlined-input-helper-text"
                                    inputProps={{
                                        'aria-label': 'input',
                                    }}
                                />
                            </div>
                            <div className="paysera-inputLabel">
                                <label htmlFor="Numri Serik">Mbiemri</label>
                                <OutlinedInput
                                    size="small"
                                    id="outlined-adornment-input"
                                    placeholder="Mbiemri"
                                    disabled
                                    type="text"
                                    value={InstitucioniServiceData.Insured}
                                    aria-describedby="outlined-input-helper-text"
                                    inputProps={{
                                        'aria-label': 'input',
                                    }}
                                />
                            </div>
                            <div className="paysera-inputLabel">
                                <label htmlFor="Numri Serik">Koment</label>
                                <OutlinedInput
                                    size="small"
                                    id="outlined-adornment-input"
                                    placeholder="Koment"
                                    disabled
                                    type="text"
                                    value={InstitucioniServiceData.Insured}
                                    aria-describedby="outlined-input-helper-text"
                                    inputProps={{
                                        'aria-label': 'input',
                                    }}
                                />
                            </div>
                            <div className="paysera-inputLabel">
                                <label className={formik.touched.Email && formik.errors.Email ? 'label-top' : ''} htmlFor="Numri Serik">Periudha Raportimit <span className="required">*</span></label>
                                <div className="input">
                                    <OutlinedInput
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Shëno email-in tuaj"
                                        name='Email'
                                        type="email"
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                        value={formik.values.Email}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.Email && formik.errors.Email}
                                    />
                                    {
                                        (formik.touched.Email && formik.errors.Email) &&
                                        (
                                            <FormHelperText>{formik.errors.Email}</FormHelperText>
                                        )
                                    }
                                </div>
                            </div>
                            <div className="paysera-inputLabel">
                                <label htmlFor="Numri Serik">Borxhi total</label>
                                <OutlinedInput
                                    size="small"
                                    id="outlined-adornment-input"
                                    placeholder="Borxhi total"
                                    disabled
                                    type="text"
                                    value={InstitucioniServiceData.Insured}
                                    aria-describedby="outlined-input-helper-text"
                                    inputProps={{
                                        'aria-label': 'input',
                                    }}
                                />
                            </div>
                            <div className="paysera-inputLabel">
                                <label htmlFor="Numri Serik">Fatura e fundit</label>
                                <OutlinedInput
                                    size="small"
                                    id="outlined-adornment-input"
                                    placeholder="Fatura e fundit"
                                    disabled
                                    type="text"
                                    value={InstitucioniServiceData.Insured}
                                    aria-describedby="outlined-input-helper-text"
                                    inputProps={{
                                        'aria-label': 'input',
                                    }}
                                />
                            </div>
                            <div className="paysera-inputLabel">
                                <label htmlFor="Numri Serik">Shuma për pagesë</label>
                                <OutlinedInput
                                    disabled
                                    size="small"
                                    id="outlined-adornment-input"
                                    type='number'
                                    placeholder="Shuma për pagesë"
                                    aria-describedby="outlined-input-helper-text"
                                    value={InstitucioniServiceData.Amount}
                                    inputProps={{
                                        'aria-label': 'input',
                                    }}
                                />
                            </div>
                            <div className="p-buttons">
                                <div className="payForm-btn">
                                    <Button type="button" variant="outlined" onClick={handleBack}>
                                        Kthehu
                                    </Button>
                                    <Button disabled type="button" variant="contained" onClick={handlePay}>
                                        Paguaj
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default KruHidrodrini_PaymentFields